// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__jHibB"};